import { NgModule } from '@angular/core';
import { RejectRegistrationComponent } from './reject-registration.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
    declarations: [
        RejectRegistrationComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        RejectRegistrationComponent
    ]
})
export class RejectRegistrationComponentModule { }